/* eslint-disable react-hooks/exhaustive-deps */
import '../organization.scss';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Divider,
  Dropdown,
  Form,
  Grid,
  Icon,
  Modal,
  Segment,
} from 'semantic-ui-react';

import plusOutline from '../../../assets/add-icon-white-bg.svg';
import downloadIcon from '../../../assets/downloadIcon.svg';
import infoIcon from '../../../assets/info-outline.svg'; // TODO: remove this when creating new cross reference while toggling button
import { CustomTable, SeeMore } from '../../../components';
import { CustomFileUpload, CustomInput } from '../../../components/form';
import {
  archiveOrgGoalReferences,
  getCrossReferenceDocumentList,
  getOrganizationGoals,
  getOrgGoalRefList,
  postCreateOrgGoalReferences,
  postCrossReferenceDocument,
  putCrossReferenceDocument,
  putOrgArchivedGoalReferences,
  putOrgGoalReferences,
} from '../../../store/actions';
import { filter, find, get, isEmpty, map, size } from '../../../utils/lodash';
import {
  crossReferenceInitialValues,
  crossReferenceValidationSchema,
} from '../../../validations/crossReferenceValidation';
import ShowMoreText from 'react-show-more-text';
import { INSTANCE_CONTACT_EMAIL } from '../../../utils/instanceConstant';
const CrossReferenceDocumentForm = ({
  isNew,
  toggle,
  user,
  crossRefCurrentDoc,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [file, setFile] = useState('');

  const crossRefDocLoading = useSelector(
    (state) => state.organization.crossRefDocLoading
  );

  const onSubmit = async (values) => {
    const { documentTitle, referenceFieldLabel } = values;

    let formData = new FormData();
    formData.append('organisationId', parseInt(user.organisationId));
    formData.append('documentTitle', documentTitle);
    formData.append('referenceFieldLabel', referenceFieldLabel);
    formData.set('uploadFile', file ? file.file : ' ');

    if (isNew) {
      const isSubmitted = await dispatch(postCrossReferenceDocument(formData));

      if (isSubmitted) {
        toggle();
      }
    } else {
      const isSubmitted = await dispatch(
        putCrossReferenceDocument(crossRefCurrentDoc.id, formData)
      );

      if (isSubmitted) {
        toggle();
      }
    }
  };

  return (
    <Formik
      onSubmit={(values) => {
        onSubmit(values);
      }}
      initialValues={crossReferenceInitialValues(crossRefCurrentDoc, isNew)}
      validationSchema={crossReferenceValidationSchema(t)}
    >
      {({ handleSubmit, errors, isSubmitting, setFieldValue }) => (
        <Form onSubmit={handleSubmit}>
          <div className="model-upper">
            <CustomInput
              id="documentTitle"
              name="documentTitle"
              labelText={t(
                'organisation.settings.reference_form.document_title'
              )}
            />
            <CustomInput
              id="referenceFieldLabel"
              name="referenceFieldLabel"
              labelText={t(
                'organisation.settings.reference_form.reference_field_label'
              )}
            />
            <CustomFileUpload
              id="file"
              labelText={t(
                'organisation.settings.reference_form.upload_reference_document'
              )}
              name="file"
              accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, application/pdf"
              buttonText={t('organisation.settings.reference_form.browse_file')}
              mediaUpload={true}
              infoMessage={t(
                'organisation.settings.reference_form.max_file_size'
              )}
              setFile={setFile}
              loading={crossRefDocLoading}
              showMsg={true}
              placeholder={t(
                'organisation.settings.reference_form.accepted_file_types'
              )}
              restrictedSize={2}
              setFieldValue={setFieldValue}
            />
          </div>
          <Divider section />

          <div className="model-below">
            <div className="model-button">
              <Button onClick={toggle} className="modal-cancel">
                {t('actions.cancel')}
              </Button>
              <Button
                loading={crossRefDocLoading}
                className="modal-proceed"
                content={t('actions.save')}
                type="submit"
              />
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

const CrossReferenceDocumentCreateModal = (props) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <Modal
      open={modal}
      onOpen={toggle}
      size={'tiny'} //  : 'small'
      trigger={
        <Dropdown.Item>
          <label>
            {t('organisation.settings.new_cross_reference_document.create_new')}
          </label>
        </Dropdown.Item>
      }
    >
      <Modal.Content>
        <div className="align-self-center justify-content-center text-center my-3">
          <img
            className="modal-report-error-img"
            alt="greenRight"
            src={infoIcon}
          />{' '}
        </div>

        <p className="text-center modal-report-error-paragraph">
          {t('organisation.settings.new_cross_reference_document.being_built')}
          <br />{' '}
          {t(
            'organisation.settings.new_cross_reference_document.in_the_meantime'
          )}
          &nbsp;(
          <span>
            <a
              className="contactUs"
              href={`mailto:${INSTANCE_CONTACT_EMAIL}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {INSTANCE_CONTACT_EMAIL}
            </a>
          </span>
          ) &nbsp;
          {t(
            'organisation.settings.new_cross_reference_document.request_suffix'
          )}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <div className="align-self-center justify-content-center text-center">
          <Button
            className="modal-proceed px-5"
            content={t('actions.got_it')}
            onClick={toggle}
          />
        </div>
      </Modal.Actions>
    </Modal>
  );
};
const CrossReferenceDocumentUpdateModal = (props) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  return (
    <Modal
      className="add-cross-ref-model"
      open={modal}
      closeIcon={<Icon onClick={toggle} name="close" className="closeicon" />}
      trigger={
        <Dropdown.Item>
          {' '}
          <label>{t('actions.edit')}</label>
        </Dropdown.Item>
      }
      onOpen={toggle}
      size="small"
    >
      <Modal.Header>
        {t(
          'organisation.settings.reference_form.update_cross_reference_document_header'
        )}
      </Modal.Header>
      <Modal.Content>
        <CrossReferenceDocumentForm {...props} isNew={false} toggle={toggle} />
      </Modal.Content>
    </Modal>
  );
};

const ReferenceForm = ({
  toggle,
  user,
  crossRefActiveDoc,
  isNew,
  goalTitle,
  goalId,
  goalCrossReferenceId,
  referencesEditArr,
  goalOptions,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [referenceArr, setReferenceArr] = useState(
    isNew
      ? [
          {
            key: 1,
            value: '',
          },
        ]
      : []
  ); // new references
  const [referenceEditArr, setReferenceEditArr] = useState(referencesEditArr); // editing references/ existing references
  const [referenceArrLength, setReferenceArrLength] = useState(isNew ? 1 : 0);

  const crossReferenceModificationLoading = useSelector(
    (state) => state.organization.crossReferenceModificationLoading
  );

  useEffect(() => {
    (async () => {
      setReferenceArr(
        isNew
          ? [
              {
                key: 1,
                value: '',
              },
            ]
          : []
      );
    })();
  }, []);

  const handleAddNewReference = () => {
    setReferenceArr([
      ...referenceArr,
      { key: referenceArrLength + 1, value: '' },
    ]);
    setReferenceArrLength(referenceArrLength + 1);
  };

  const onDeleteReference = (isExistingReference, key) => {
    const references = !isExistingReference ? referenceArr : referenceEditArr;
    const referenceNewArray = filter(references, (f) => f.key !== key);

    !isExistingReference
      ? setReferenceArr(referenceNewArray)
      : setReferenceEditArr(referenceNewArray);
  };

  const onChangeGoalReferences = async (isExistingReference, value, key) => {
    const references = !isExistingReference ? referenceArr : referenceEditArr;
    const editedReferences = map(references, (reference) => {
      if (reference.key === key) {
        return {
          key: key,
          value: value.trim(),
        };
      } else {
        return reference;
      }
    });
    !isExistingReference
      ? setReferenceArr(editedReferences)
      : setReferenceEditArr(editedReferences);
  };

  const onSaveGoalReferences = async (event, values) => {
    const { referenceGoal } = values;

    const newReferencesList = map(referenceArr, (reference) => reference.value);
    const existingReferencesList = !isNew ? referenceEditArr : [];
    const documentId = crossRefActiveDoc.id;

    const isModalHidden = isNew
      ? dispatch(
          postCreateOrgGoalReferences(
            referenceGoal,
            documentId,
            newReferencesList
          )
        )
      : dispatch(
          putOrgGoalReferences(
            goalId,
            documentId,
            goalCrossReferenceId,
            existingReferencesList,
            newReferencesList
          )
        );

    isModalHidden && toggle();
  };

  const deletingArrLength = isNew
    ? referenceArr.length
    : referenceArr.length + referenceEditArr.length;

  return (
    <AvForm
      onValidSubmit={(event, values) => {
        onSaveGoalReferences(event, values);
      }}
    >
      <div className="model-upper">
        {isNew ? (
          <>
            {/* creating goal dropdown */}
            <AvField
              label={t('common.goal')}
              name="referenceGoal"
              type="select"
              validate={{
                required: {
                  value: true,
                  errorMessage: t('formulary.validation.goal_required'),
                },
              }}
            >
              <option value="" defaultValue disabled>
                {t('formulary.placeholder.select_a_goal')}
              </option>
              {map(goalOptions, (e) => (
                <option key={e.key} value={e.value}>
                  {' '}
                  {e.text}
                </option>
              ))}
            </AvField>
            <p className="text-muted">
              {t('organisation.settings.once_selected_goal_immutable')}
            </p>
          </>
        ) : (
          <>
            {/* editing ui label */}
            <AvField
              name="referenceGoal"
              label={t('common.goal')}
              value={goalTitle}
              required
              disabled
            />
          </>
        )}
        <label className="modal-subheader">
          {crossRefActiveDoc.referenceFieldLabel}
        </label>
        {!isNew &&
          referenceEditArr.map((item) => {
            return (
              <div className="d-flex cross-reference-label">
                <AvField
                  className={deletingArrLength > 1 ? 'textarea-with-btn' : ''}
                  type="textarea"
                  name={`goalReference_${item.key}`}
                  required
                  onChange={(e) =>
                    onChangeGoalReferences(true, e.target.value, item.key)
                  }
                  value={item.value}
                  validate={{
                    required: {
                      value: true,
                      errorMessage: t(
                        'organisation.settings.reference_form.reference_required'
                      ),
                    },
                  }}
                  readOnly={crossReferenceModificationLoading}
                />

                {deletingArrLength > 1 ? (
                  <Button
                    onClick={() => onDeleteReference(true, item.key)}
                    icon="trash"
                    attached="right"
                    disabled={crossReferenceModificationLoading}
                  ></Button>
                ) : null}
              </div>
            );
          })}

        {referenceArr.map((item) => {
          return (
            <div className="d-flex cross-reference-label">
              <AvField
                className={deletingArrLength > 1 ? 'textarea-with-btn' : ''}
                type="textarea"
                name={`goalReference_${item.key}`}
                value={item.value}
                required
                onChange={(e) =>
                  onChangeGoalReferences(false, e.target.value, item.key)
                }
                validate={{
                  required: {
                    value: true,
                    errorMessage: t(
                      'organisation.settings.reference_form.reference_required'
                    ),
                  },
                }}
                readOnly={crossReferenceModificationLoading}
              />

              {deletingArrLength > 1 ? (
                <Button
                  onClick={() => onDeleteReference(false, item.key)}
                  icon="trash"
                  attached="right"
                  disabled={crossReferenceModificationLoading}
                ></Button>
              ) : null}
            </div>
          );
        })}

        <div className="d-flex align-items-end flex-column">
          <div>
            <Button
              onClick={handleAddNewReference}
              className="btn-add-ref"
              type="button"
              disabled={crossReferenceModificationLoading}
            >
              <span>
                <img className="plus-icon" alt="plus" src={plusOutline} />{' '}
                {t('organisation.settings.reference_form.add_more_references')}
              </span>
            </Button>
          </div>
        </div>
      </div>
      <Divider section />

      <div className="model-below">
        <div className="model-button">
          <Button onClick={toggle} className="Secondary-Button">
            {t('actions.cancel')}
          </Button>
          <Button
            type="submit"
            className="Primary-Button"
            content={t('actions.save')}
            loading={crossReferenceModificationLoading}
          />
        </div>
      </div>
    </AvForm>
  );
};

const ReferenceCreate = (props) => {
  const [modal, setModal] = useState(false);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    (async () => {
      await dispatch(getOrganizationGoals());
    })();
  }, []);

  return (
    <Modal
      open={modal}
      size="small"
      closeIcon={<Icon onClick={toggle} name="close" className="closeicon" />}
      className="add-ref-model"
      trigger={
        <div className="ref-plans-show">
          <div className="add-new-ref">
            <Button
              onClick={toggle}
              className="Primary-Button add-reference-btn"
            >
              <Icon name="plus" />
              {t('specific_actions.add_reference')}
            </Button>
          </div>
        </div>
      }
    >
      <Modal.Header>
        {t('actions.add')}
        {props.crossRefActiveDoc.referenceFieldLabel
          ? props.crossRefActiveDoc.referenceFieldLabel
          : t('common.reference')}
      </Modal.Header>
      <Modal.Content>
        <ReferenceForm {...props} toggle={toggle} isNew={true}></ReferenceForm>
      </Modal.Content>
    </Modal>
  );
};

const ReferenceUpdate = (props) => {
  const [modal, setModal] = useState(false);
  const { t } = useTranslation();

  const toggle = () => {
    setModal(!modal);
  };

  const referencesEditArr = map(props.references, (reference) => {
    return {
      key: reference.id,
      value: reference.crossReferenceLabel,
    };
  });

  return (
    <Modal
      open={modal}
      size="small"
      closeIcon={<Icon onClick={toggle} name="close" className="closeicon" />}
      className="edit-ref-model"
      trigger={
        <label className="org-users-actions-warn default-color">
          {t('actions.edit')}
        </label>
      }
      onOpen={toggle}
    >
      <Modal.Header>
        {t('actions.edit')} {props.crossRefActiveDoc.referenceFieldLabel}
      </Modal.Header>
      <Modal.Content>
        <ReferenceForm
          {...props}
          toggle={toggle}
          referencesEditArr={referencesEditArr}
          isNew={false}
        ></ReferenceForm>
      </Modal.Content>
    </Modal>
  );
};

const UpdateReference = ({
  user,
  crossRefActiveDoc,
  goalCrossReferenceId,
  references,
  goalOptions,
  goalId,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [updateReferenceArr, setUpdateReferenceArr] = useState([]);

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  useEffect(() => {
    const refArr = map(references, (m) => m.crossReferenceLabel);
    setUpdateReferenceArr(refArr);
  }, []);

  const handleValidSubmit = async (event, values) => {
    const { referenceEditNewGoalId } = values;

    dispatch(
      putOrgArchivedGoalReferences(
        goalId, // existing goal id
        referenceEditNewGoalId, // new goal id (transfer references to old goal to new goal)
        crossRefActiveDoc.id,
        goalCrossReferenceId,
        updateReferenceArr
      )
    );
  };

  return (
    <Modal
      trigger={
        <label className="org-users-actions-warn default-color">
          {t('organisation.settings.update_reference_trigger')}
        </label>
      }
      size="tiny"
      open={modal}
      onOpen={toggle}
      closeIcon={<Icon onClick={toggle} name="close" className="closeicon" />}
      className="edit-ref-model"
    >
      <Modal.Header>
        {t('actions.update')}
        {crossRefActiveDoc.referenceFieldLabel
          ? crossRefActiveDoc.referenceFieldLabel
          : null}
      </Modal.Header>
      <Modal.Content>
        <AvForm
          onValidSubmit={(event, values) => {
            handleValidSubmit(event, values);
          }}
        >
          <div className="model-upper">
            <AvField
              label={t('common.goal')}
              name="referenceEditNewGoalId"
              type="select"
              validate={{
                required: {
                  value: true,
                  errorMessage: t('formulary.validation.goal_required'),
                },
              }}
            >
              <option value="" defaultValue disabled>
                {t('formulary.placeholder.select_a_goal')}
              </option>
              {map(goalOptions, (e) => (
                <option key={e.key} value={e.value}>
                  {' '}
                  {e.text}
                </option>
              ))}
            </AvField>
            <p className="text-muted">
              {t('organisation.settings.once_selected_goal_immutable')}
            </p>
            <div>
              <p className="modal-subheader">{t('common.references')}</p>

              <ul className="ref-ul-custom">
                {map(updateReferenceArr, (item, i) => {
                  return <li> {item}</li>;
                })}
              </ul>
            </div>
          </div>

          <Divider section />
          <div className="model-below">
            <div className="model-button">
              <Button onClick={toggle} className="modal-cancel">
                {t('actions.cancel')}
              </Button>
              <Button
                className="modal-proceed"
                content={t('actions.save')}
                type="submit"
              />
            </div>
          </div>
        </AvForm>
      </Modal.Content>
    </Modal>
  );
};

const ArchiveGoalReferences = ({
  goalId,
  goalReferenceId,
  user,
  crossRefActiveDoc,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [modal, setModal] = useState(false);

  const toggle = () => {
    setModal(!modal);
  };

  const handleValidSubmit = (goalId, goalReferenceId) => {
    const documentId = crossRefActiveDoc.id;
    dispatch(archiveOrgGoalReferences(documentId, goalId, goalReferenceId));
    toggle();
  };

  return (
    <Modal
      open={modal}
      size="tiny"
      trigger={
        <label className="ref-delete-label">{t('actions.archive')}</label>
      }
      onOpen={toggle}
    >
      <Modal.Header>
        {t('organisation.settings.archive_goal_references')}
      </Modal.Header>
      <Modal.Content>
        {t('organisation.settings.confirm_archive')}
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={toggle} className="modal-cancel">
          {t('actions.cancel')}
        </Button>
        <Button
          onClick={() => handleValidSubmit(goalId, goalReferenceId)}
          className="modal-proceed"
          content={t('actions.archive')}
        />
      </Modal.Actions>
    </Modal>
  );
};

export const CrossReference = (props) => {
  const [crossRefCurrentDoc, setCrossRefCurrentDoc] = useState({});
  const [crossRefActiveDoc, setCrossRefActiveDoc] = useState({});
  const [goalOptions, setGoalOptions] = useState([]);
  const { t } = useTranslation();

  const crossRefDocuments = useSelector(
    (state) => state.organization.crossRefDocuments
  );
  const orgGoalsReferences = useSelector(
    (state) => state.organization.orgGoalsReferences
  );
  const organisationGoalsReferencesLoading = useSelector(
    (state) => state.organization.organisationGoalsReferencesLoading
  );
  const user = useSelector((state) => state.authentication.user);
  const organisationGoals = useSelector(
    (state) => state.organization.organisationGoals
  );

  const dispatch = useDispatch();

  useEffect(() => {
    (async () => {
      // get cross reference documents
      dispatch(getCrossReferenceDocumentList());
      dispatch(getOrganizationGoals());
    })();
  }, []);

  const setOrganisationGoals = async () => {
    const goalOptions = map(organisationGoals, (item, i) => ({
      key: item.id,
      value: item.id,
      text: item.goalTitle,
    }));

    setGoalOptions([...goalOptions]);
  };

  useEffect(() => {
    (async () => {
      await setOrganisationGoals();
    })();
  }, [organisationGoals]);

  useEffect(() => {
    const currentRefDoc = find(
      crossRefDocuments,
      (docItem) => docItem.documentEndedDateTime === null
    );
    if (currentRefDoc !== undefined) {
      setCrossRefCurrentDoc(currentRefDoc);
      setCrossRefActiveDoc(currentRefDoc);
    }
  }, [crossRefDocuments]);

  //get organisation goal with included references
  useEffect(() => {
    if (crossRefCurrentDoc && Object.keys(crossRefCurrentDoc).length !== 0) {
      dispatch(getOrgGoalRefList(crossRefCurrentDoc.id));
    }
  }, [crossRefCurrentDoc]);

  const referenceGroup = (props) => {
    const { item, rest } = props;
    return (
      <div
        className={
          rest.isArchived
            ? 'reference-mainText-muted item'
            : 'reference-mainText item'
        }
      >
        {' '}
        {!isEmpty(item.crossReferenceLabel) ? (
          <ShowMoreText
            lines={2}
            more={t('common.read_more')}
            less={t('common.read_less')}
            anchorClass="show-more-less-clickable"
            expanded={false}
            truncatedEndingComponent={'... '}
            className="pre-line"
          >
            <p>{item.crossReferenceLabel}</p>
          </ShowMoreText>
        ) : (
          '-'
        )}
      </div>
    );
  };

  const columns = [
    {
      title: t('common.goal'),
      width: 3,
      render: (data) => {
        let goalTitle = '';
        let labelTitle = '';

        const isGoalArchived = get(data, 'goal.isArchived', false);
        const isGoalDeleted = get(data, 'goal.isDeleted', false);

        if (size(data) > 0) {
          goalTitle = get(data, 'goal.goalTitle', '');
        }
        if (!isEmpty(goalTitle)) {
          goalTitle = goalTitle.split('.');
        }

        // set label title for deleted or archived goals
        if (isGoalArchived) {
          labelTitle = t('organisation.settings.archived_goal');
        } else if (isGoalDeleted) {
          labelTitle = t('organisation.settings.deleted_goal');
        }

        return (
          <>
            <div className="reference-container">
              <label
                className={
                  isGoalArchived || isGoalDeleted
                    ? 'reference-mainText-muted'
                    : 'reference-mainText'
                }
              >
                {' '}
                {!isEmpty(goalTitle) ? goalTitle : '-'}
              </label>
            </div>
            {labelTitle && <span className="archived-lbl">{labelTitle}</span>}
          </>
        );
      },
    },
    {
      title: crossRefCurrentDoc.referenceFieldLabel
        ? crossRefCurrentDoc.referenceFieldLabel
        : null,
      width: 7,
      render: (data) => {
        let references = [];
        let isArchived = false;
        const isGoalArchived = get(data, 'goal.isArchived', false);
        if (data) {
          references = get(data, 'references', []);
          isArchived = get(data, 'isArchived', false);
        }

        return size(references) > 3 ? (
          <div>
            <SeeMore
              minCount={3}
              dataSet={references}
              CustomComponent={referenceGroup}
              isView={true}
              rest={{ isArchived }}
            />
          </div>
        ) : (
          <div>
            {map(references, (ref) => {
              return (
                <label
                  className={
                    isGoalArchived
                      ? // isArchived
                        'reference-mainText-muted item'
                      : 'core-data-label'
                  }
                >
                  {!isEmpty(ref.crossReferenceLabel) ? (
                    <ShowMoreText
                      lines={2}
                      more={t('common.read_more')}
                      less={t('common.read_less')}
                      anchorClass="show-more-less-clickable"
                      expanded={false}
                      truncatedEndingComponent={'... '}
                      className="pre-line"
                    >
                      <p>{ref.crossReferenceLabel}</p>
                    </ShowMoreText>
                  ) : (
                    '-'
                  )}
                </label>
              );
            })}
          </div>
        );
      },
    },
    {
      title: '',
      width: 1,
      render: (data) => {
        const goalTitle = get(data, 'goal.goalTitle', '');
        const isGoalArchived = get(data, 'goal.isArchived', false);
        const goalCrossReferenceId = data.id;
        const isArchived = get(data, 'isArchived', false);

        const references = get(data, 'references', []);

        const goalId = get(data, 'goalId', null);
        const goalReferenceId = get(data, 'id');

        return (
          <div className="action-container">
            {isArchived || isGoalArchived ? (
              <UpdateReference
                {...props}
                user={user}
                crossRefActiveDoc={crossRefActiveDoc}
                goalId={data.goalId}
                goalCrossReferenceId={goalCrossReferenceId}
                goalTitle={goalTitle}
                references={references}
                goalOptions={goalOptions}
              />
            ) : (
              <ReferenceUpdate
                {...props}
                user={user}
                crossRefActiveDoc={crossRefActiveDoc}
                goalId={data.goalId}
                goalCrossReferenceId={goalCrossReferenceId}
                goalTitle={goalTitle}
                references={references}
              />
            )}

            <ArchiveGoalReferences
              goalId={goalId}
              goalReferenceId={goalReferenceId}
              crossRefActiveDoc={crossRefActiveDoc}
              user={user}
            />
          </div>
        );
      },
    },
  ];

  return (
    <div>
      <Segment
        className="org-cross-ref-segment"
        loading={organisationGoalsReferencesLoading}
      >
        <div className="financial-method-container content-segment-settings">
          <Grid>
            <Grid.Row>
              <Grid.Column width={5}>
                <div className="financial-method-radio">
                  <label className="ref-label">
                    {t('organisation.settings.reference_document')}
                  </label>

                  <span>
                    <div className="ref-download-link">
                      {!isEmpty(crossRefCurrentDoc) ? (
                        crossRefCurrentDoc.document ? (
                          <div>
                            <img
                              className="plus-icon"
                              alt="plus"
                              src={downloadIcon}
                            />{' '}
                            <a
                              href={crossRefCurrentDoc.document.documentUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {crossRefCurrentDoc.documentTitle}
                            </a>
                          </div>
                        ) : (
                          <span className="ref-label-code">
                            {crossRefCurrentDoc.documentTitle}
                          </span>
                        )
                      ) : (
                        ''
                      )}
                    </div>
                  </span>
                </div>
              </Grid.Column>
              <Grid.Column width={5}>
                <div className="financial-method-radio">
                  <label className="ref-label">
                    {t(
                      'organisation.settings.reference_form.reference_field_label'
                    )}{' '}
                  </label>
                  <span className="ref-label-code">
                    {!isEmpty(crossRefCurrentDoc)
                      ? crossRefCurrentDoc.referenceFieldLabel
                      : ''}
                  </span>
                </div>
              </Grid.Column>
              <Grid.Column width={6}>
                <div className="menu-dropdown">
                  <Dropdown
                    className="select-hover"
                    icon="ellipsis vertical"
                    direction="left"
                    inline
                    selectOnBlur={false}
                  >
                    <Dropdown.Menu>
                      <CrossReferenceDocumentUpdateModal
                        {...props}
                        crossRefDocuments={crossRefDocuments}
                        user={user}
                        crossRefCurrentDoc={crossRefCurrentDoc}
                      />

                      {/* <Dropdown.Item
                        text="Manage Groups"
                        className="dropdown-customItem"
                      > */}
                      <CrossReferenceDocumentCreateModal
                        {...props}
                        user={user}
                        crossRefCurrentDoc={crossRefCurrentDoc}
                      />
                      {/* </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>

        <ReferenceCreate
          {...props}
          user={user}
          crossRefActiveDoc={crossRefActiveDoc}
          goalOptions={goalOptions}
        />

        <CustomTable
          header
          columns={columns}
          data={orgGoalsReferences}
          customClass="org-ref-table"
          height={true}
          emptyMessage={t('organisation.settings.no_reference_added')}
          keyExtractor={(item, index) => item.id}
        />
      </Segment>
    </div>
  );
};
